<template>
  <div class="flex flex-col gap-6 mt-5">
    <div id="job_title" class="flex flex-col gap-2">
      <span class="secondary_color text-[13px]">Job title</span>
      <a-select
        v-model:value="localJobTitles"
        mode="multiple"
        placeholder="Select job title(s)"
        :options="jobTitleOptions"
        :maxTagCount="3"
      >
        <template #suffixIcon>
          <ThemeImage
            :icon="imageNames.BOTTOM_ARROW"
            alt="bottom_white_arrow"
            class="size-4 opacity-50"
          />
        </template>
      </a-select>
    </div>

    <div id="seniority" class="flex flex-col gap-2">
      <span class="secondary_color text-[13px]">Seniority</span>
      <a-select
        v-model:value="localSeniority"
        mode="multiple"
        placeholder="Select seniority(s)"
        :options="seniorityOptions"
        :maxTagCount="3"
      >
        <template #suffixIcon>
          <ThemeImage
            :icon="imageNames.BOTTOM_ARROW"
            alt="bottom_white_arrow"
            class="size-4 opacity-50"
          />
        </template>
      </a-select>
    </div>

    <div id="department" class="flex flex-col gap-2">
      <span class="secondary_color text-[13px]">Department</span>
      <a-select
        v-model:value="localDepartments"
        mode="multiple"
        placeholder="Select department(s)"
        :options="departmentOptions"
        :maxTagCount="3"
      >
        <template #suffixIcon>
          <ThemeImage
            :icon="imageNames.BOTTOM_ARROW"
            alt="bottom_white_arrow"
            class="size-4 opacity-50"
          />
        </template>
      </a-select>
    </div>

    <div id="add_to_sequence" class="flex flex-col gap-2">
      <span class="secondary_color text-[13px]"
        >Add to {{ featureNames.SEQUENCES }}</span
      >
      <a-select
        v-model:value="localSequenceId"
        :placeholder="`Select ${featureNames.SEQUENCES}`"
      >
        <template #suffixIcon>
          <ThemeImage
            :icon="imageNames.BOTTOM_ARROW"
            alt="bottom_white_arrow"
            class="size-4 opacity-50"
          />
        </template>

        <a-select-option
          v-for="(sequence, index) in sequences"
          :key="`${sequence?.id}_${index}`"
          :value="sequence?.id"
        >
          {{ sequence?.name }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

import { imageNames } from "@/src/constants/imageConstants.js";
import { featureNames } from "@/src/constants/globalConstants";

const props = defineProps({
  modelValue: { type: Object, required: true },
  jobTitleOptions: { type: Array, default: () => [] },
  seniorityOptions: { type: Array, default: () => [] },
  departmentOptions: { type: Array, default: () => [] },
  sequences: { type: Array, default: () => [] },
});

const localJobTitles = ref([]);
const localSeniority = ref([]);
const localDepartments = ref([]);
const localSequenceId = ref(null);

const initLocalValues = () => {
  try {
    localJobTitles.value = props.modelValue?.metadata?.job_titles || [];
    localSeniority.value = props.modelValue?.metadata?.seniority || [];
    localDepartments.value = props.modelValue?.metadata?.departments || [];
    localSequenceId.value = props.modelValue?.metadata?.sequence_id || null;
  } catch (error) {
    console.error("An error occurred while initiating local values: ", error);
  }
};

const updateMetadata = () => {
  try {
    props.modelValue.metadata = {
      job_titles: localJobTitles.value,
      seniority: localSeniority.value,
      departments: localDepartments.value,
      sequence_id: localSequenceId.value,
    };
  } catch (error) {
    console.error("An error occurred while updating metadata: ", error);
  }
};

watch(() => props.modelValue.metadata, initLocalValues, { immediate: true });

watch(
  [localJobTitles, localSeniority, localDepartments, localSequenceId],
  updateMetadata,
  { deep: true },
);

watch(
  () => props.modelValue.step_type,
  (newVal) => {
    if (newVal === "" || newVal !== "MULTI_THREADING") {
      localJobTitles.value = [];
      localSeniority.value = [];
      localDepartments.value = [];
      localSequenceId.value = null;
    }
  },
);
</script>
